fragment usageDataInfo on UsageData {
  companyName
  siteName
  date
  value
}
